import { useContext } from 'react';
import { creditPlanContext } from './context';
import { useGetAllCreditPlansQuery } from '@/redux/api/client/creditPlan';
import { useAuth } from 'react-oidc-context';
import {
  selectCreditPlan,
  selectCreditPlans,
  selectCreditPlansFetchStatus
} from '@/redux/selectors/creditPlanSelectors';
import { useAppSelector } from '@/hooks';

export function useCreditPlanContext() {
  const context = useContext(creditPlanContext);
  if (!context) {
    throw new Error('useCreditPlanContext must be used within a CreditPlanProvider');
  }
  return context;
}

/**
 * create helper hooks to ensure credit plans are preloaded when using the data
 * so that we can guarantee the data is available
 */

/** */
function usePreloadCreditPlans() {
  const auth = useAuth();

  useGetAllCreditPlansQuery(undefined, {
    skip: !auth.isAuthenticated
  });

  return !auth.isAuthenticated;
}

export function useGetCreditPlans() {
  const skip = usePreloadCreditPlans();

  const isLoading = useAppSelector(selectCreditPlansFetchStatus) === 'pending' && !skip;
  const creditPlans = useAppSelector(selectCreditPlans);

  return [creditPlans, { isLoading }] as const;
}

export function useGetCreditPlan(jurisdiction?: string) {
  const skip = usePreloadCreditPlans();

  const isLoading = useAppSelector(selectCreditPlansFetchStatus) === 'pending' && !skip;
  const creditPlan = useAppSelector(state => selectCreditPlan(state, jurisdiction));

  return [creditPlan, { isLoading }] as const;
}
